import Sidebar from './sidebar.vue';

export default Sidebar;